var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{staticClass:"mt-10",attrs:{"indeterminate":true,"color":"primary","size":"100"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }